module.exports = __webpack_public_path__ + "templates/cashierSearch.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/core/components/cashierSearch/cashierSearch.html
// module id = 291
// module chunks = 15